import { render, staticRenderFns } from "./highlightFilter.vue?vue&type=template&id=63f1ca3a&scoped=true&"
import script from "./highlightFilter.vue?vue&type=script&lang=js&"
export * from "./highlightFilter.vue?vue&type=script&lang=js&"
import style0 from "./highlightFilter.vue?vue&type=style&index=0&id=63f1ca3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f1ca3a",
  null
  
)

export default component.exports